/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { Link } from "react-router-dom";
import LegalPageLayout from "./LegalPageLayout";

export default function CommunityGuidelinesPage() {
  return (
    <LegalPageLayout
      testid="page-community-guidelines"
      eyebrow="— Legal"
      title="Community Guidelines"
      subtitle="How we keep the DONiTSH!T ecosystem respectful, safe, and useful for everyone."
      lastUpdated="August 2026"
    >
      <p>
        DONiTSH!T is a wellness community. These Guidelines apply
        everywhere on our website, our mobile apps, our marketplace, and
        in any messages you send through DONiTSH!T. Violations may
        result in content removal, listing removal, or account
        suspension.
      </p>

      <h2>Respect and Safety</h2>
      <ul>
        <li>No harassment, threats, intimidation, or bullying</li>
        <li>
          No hate speech or discrimination on the basis of race,
          ethnicity, national origin, religion, gender, gender identity,
          sexual orientation, disability, age, or immigration status
        </li>
        <li>
          No content that sexualizes minors under any circumstances
        </li>
        <li>
          No content that promotes or incites violence, self-harm, or
          illegal activity
        </li>
        <li>No exploitation of vulnerable users</li>
      </ul>

      <h2>Sexual and Explicit Content</h2>
      <ul>
        <li>
          No pornographic, sexually explicit, or graphically violent
          content
        </li>
        <li>
          Adult relationship content in the DONiTSH!T mobile experiences
          (Luv Connect / Couples Connect) is restricted to users{" "}
          <strong>18 or older</strong>. Minors must not create accounts
          in, misrepresent their age within, or attempt to access those
          experiences. Any attempt to circumvent age gating is a
          violation.
        </li>
      </ul>

      <h2>Authenticity</h2>
      <ul>
        <li>
          No impersonation of any person, business, practitioner, or
          organization
        </li>
        <li>
          No fraudulent business listings, fake credentials, misleading
          service descriptions, or fake reviews
        </li>
        <li>
          Businesses must be authorized to list — the listed contact
          must be a real, verifiable representative of the business
        </li>
      </ul>

      <h2>Marketplace Conduct</h2>
      <ul>
        <li>
          Businesses must accurately describe their services,
          qualifications, and pricing
        </li>
        <li>
          Practitioners must operate within their licensed scope of
          practice
        </li>
        <li>
          Communications with users through the marketplace must be
          professional and respectful
        </li>
        <li>
          Member Benefits (offers and promo codes) must be honored as
          advertised
        </li>
      </ul>

      <h2>Ask Donny Conduct</h2>
      <ul>
        <li>
          Do not attempt to jailbreak, manipulate, or use Ask Donny to
          generate content that violates these Guidelines
        </li>
        <li>
          Do not rely on Ask Donny for emergency, medical, or crisis
          decisions — please contact appropriate professionals or
          emergency services. Country-specific crisis lines are listed
          on the <Link to="/support">Support page</Link>.
        </li>
      </ul>

      <h2>Reporting and Enforcement</h2>
      <p>
        If you encounter content, a listing, or behavior that violates
        these Guidelines:
      </p>
      <ul>
        <li>
          Use the <Link to="/support">Support page</Link> contact form
          with topic "Report content" or "Report business"
        </li>
        <li>
          Include the URL, business name, or context so our team can
          investigate
        </li>
        <li>Serious safety concerns are reviewed on a priority basis</li>
      </ul>
      <p>
        <strong>Reporting and safety controls today.</strong> At the time
        of publication, the primary safety controls for user-to-user
        experiences (for example, Luv Connect and Couples Connect in the
        mobile apps) are provided in-app. On the website, the Support
        contact form is the current reporting path.
      </p>

      <h2>Enforcement Actions</h2>
      <p>
        Depending on severity and context, DONiTSH!T may:
      </p>
      <ul>
        <li>Remove content or listings</li>
        <li>Restrict access to specific features</li>
        <li>Suspend or terminate an account</li>
        <li>Report unlawful conduct to appropriate authorities</li>
      </ul>

      <h2>Appeals</h2>
      <p>
        If you believe an enforcement action was taken in error, reply
        to the enforcement notice or contact us through the{" "}
        <Link to="/support">Support page</Link> with the topic "Appeal."
      </p>
    </LegalPageLayout>
  );
}
